import React from 'react'
import RegionSelect from './RegionSelect'
import MultiSelect from './MultiSelect'
import { without } from 'lodash'

interface MultiRegionSelectProps {
  values: string[]
  onChange: (regions: string[]) => void
}

export default function MultiRegionSelect({ values, onChange }: MultiRegionSelectProps) {
  const buttonProps = {
    iconName: 'plus',
    minimal: true,
    blue: true,
  }
  return (
    <MultiSelect
      title="Regions"
      values={values.map((v) => (
        <span key={v}>{v}</span>
      ))}
      select={
        <RegionSelect
          multi
          value={null}
          btnText="Add"
          onChange={(v) =>
            values.includes(v) ? onChange(without(values, v)) : onChange([...values, v])
          }
          itemDisabled={(item) => values.includes(item)}
          {...{ buttonProps }}
        />
      }
      onRemove={(v) => onChange(values.filter((av) => av !== v))}
    />
  )
}
